import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export const firstbaseCpReceiptLineSchema = yup.object().shape({
  orderLinePoNumber: yup.string().nullable().optional(),
  orderLineNumber: yup.string().nullable().optional(),
  quantity: yup.string().nullable().optional(),
  type: yup.string().nullable().optional(),
})

export const firstbaseCpReceiptFileDataSchema = yup.object().shape({
  lines: yup.array().of(firstbaseCpReceiptLineSchema).required(),
})

export type FirstbaseCpReceiptLineData = yup.InferType<typeof firstbaseCpReceiptLineSchema>

export type FirstbaseCpReceiptFileData = yup.InferType<typeof firstbaseCpReceiptFileDataSchema>

type RequiredFileData = MakeRequiredAndNullable<FirstbaseCpReceiptFileData>

export const firstbaseCpReceiptFileMappings: RequiredFileData = {
  lines: [
    {
      orderLinePoNumber: '4dc971e8-a063-42f0-86f5-ed1cad2cef0a',
      orderLineNumber: '3e50bf74-8d80-4d96-8809-1146618a710d',
      quantity: '5dd95de9-ae1d-4b65-9c1e-6a9174d7dc49',
      type: '2407c78f-b2ba-4afa-841a-da5c8eb28cd2',
    },
  ],
}
